import { useState, useEffect } from 'react';
import { Modal } from 'antd';

const ImagePreviewModal = ({
    src,
    alt,
    children,
    fallback,
    thumbWidth,
    thumbHeight,
    modalWidth = 600,
    modalHeight = 600,
    className,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [imgSrc, setImgSrc] = useState(src);
    const [zoom, setZoom] = useState(1);

    useEffect(() => {
        setImgSrc(src);
    }, [src]);

    const handleOpen = () => {
        setIsOpen(true);
        setZoom(1); // reset zoom when opening
    };

    const handleClose = () => {
        setIsOpen(false);
        setZoom(1);
    };

    const handleZoomToggle = () => {
        setZoom(prev => (prev === 1 ? 2 : 1)); // toggle zoom
    };

    const handleWheelZoom = (e) => {
        e.preventDefault();
        setZoom(prev => {
            const newZoom = prev + (e.deltaY > 0 ? -0.1 : 0.1);
            return Math.min(Math.max(newZoom, 1), 4); // limit 1x to 4x
        });
    };

    return (
        <>
            <div style={{ display: 'inline-block', cursor: 'pointer' }} onClick={handleOpen}>
                {children ? children : (
                    <img
                        src={imgSrc}
                        alt={alt}
                        className={className}
                        style={{ width: thumbWidth, height: thumbHeight, objectFit: 'cover' }}
                        onError={() => setImgSrc(fallback)}
                    />
                )}
            </div>

            <Modal
                open={isOpen}
                footer={null}
                onCancel={handleClose}
                centered
                width={modalWidth}
                styles={{
                    body: {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: modalHeight,
                        padding: 0,
                        overflow: 'hidden'
                    }
                }}
            >
                <div
                    onWheel={handleWheelZoom}
                    style={{
                        overflow: 'auto',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: zoom > 1 ? 'zoom-out' : 'zoom-in'
                    }}
                >
                    <img
                        src={imgSrc}
                        alt={alt}
                        onClick={handleZoomToggle}
                        style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                            transform: `scale(${zoom})`,
                            transition: 'transform 0.2s ease'
                        }}
                        onError={() => setImgSrc(fallback)}
                    />
                </div>
            </Modal>
        </>
    );
};

export default ImagePreviewModal;